export default __webpack_public_path__ + "static/media/TableCall.c3364402.svg";